import * as _4 from 'lodash4';

export class RemoveClassOnLeaveController {
  constructor(
    protected $rootScope: any,
    protected $state: any,
    protected $element: any,
    protected $scope: any,
    protected $attrs: any
  ) {}
}

function RemoveClassOnLeave() {
  return {
    restrict: 'A',
    controller: RemoveClassOnLeaveController
  };
}

angular.module('capability-ng-academic-planner').directive('removeClassOnLeave', RemoveClassOnLeave);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/remove_class_on_leave/remove_class_on_leave.ts